import React from "react";
import EventForm from "./EventForm";

export default function CreateEvent() {
  return (
    <div className="p-16 border rounded-lg">
      <EventForm />
    </div>
  );
}
